import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CreateLearnerState } from "./create-learner.state";
import { StoreConstants } from "src/app/constants/StoreConstants";
import { AddLearnerDto } from "src/app/_models/AddLearnerDto";
import { Userprofile } from "src/app/_models/Userprofile";
import { HttpErrorResponse } from "@angular/common/http";

export const selectCreateLearnerState = createFeatureSelector<CreateLearnerState>(StoreConstants.STATE_CLS);

export const selectLearnerDto = createSelector(
  selectCreateLearnerState,
  (state: CreateLearnerState): AddLearnerDto => state.learner
);

export const selectCreateLearnerResult = createSelector(
  selectCreateLearnerState,
  (state: CreateLearnerState): Userprofile => state.result
);

export const selectCreateLearnerError = createSelector(
  selectCreateLearnerState,
  (state: CreateLearnerState): HttpErrorResponse => state.error
);

export const selectCreateLearnerLoader = createSelector(
  selectCreateLearnerState,
  (state: CreateLearnerState): boolean => state.loading
);